import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faBadgePercent,
  faGrid2Plus,
  faPlus,
  faTag,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';
import emptyStateImg from '/static/images/otp-offer-empty-state.png';

type Option = {
  icon: IconProp;
  title: string;
  details: string | string[];
};

const options: Option[] = [
  {
    icon: faTag,
    title: 'Sell your content items',
    details: 'Put a price tag on your single content items.',
  },
  {
    icon: faGrid2Plus,
    title: 'Mix and match',
    details:
      'Pack them up - OTP programs, features and items all coming together.',
  },
  {
    icon: faBadgePercent,
    title: 'Apply discounts',
    details:
      'Experiment with discounting models. Sell your items as “3 for 2” etc.',
  },
];

export const OtpBundleEmptyState = ({
  addBundle,
}: {
  addBundle: () => void;
}) => (
  <div className="flex flex-col lg:flex-row justify-between gap-4 bg-white rounded-[10px] p-6">
    <div className="flex flex-col gap-6">
      <Typography variant="headline" size="small">
        Create your first Offer
      </Typography>
      <div className="flex flex-col gap-4 flex-grow">
        {options.map(({ title, icon, details }) => (
          <div key={title} className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <FontAwesomeIcon icon={icon} className="w-[20px]" />
              <Typography variant="body" size="large">
                {title}
              </Typography>
            </div>
            <div className="flex flex-col">
              {(Array.isArray(details) ? details : [details]).map((detail) => (
                <Typography
                  key={detail}
                  variant="body"
                  size="medium"
                  className={clsx('pl-7', sprinkles({ color: 'N-80' }))}
                >
                  {detail}
                </Typography>
              ))}
            </div>
          </div>
        ))}
      </div>
      <Button
        leftIcon={faPlus}
        color="neutral"
        className="w-max"
        onClick={addBundle}
      >
        Add new offer
      </Button>
    </div>
    <img
      src={emptyStateImg}
      className="max-w-[full] h-full md:max-w-[50%] md:max-h-[300px]"
    />
  </div>
);
